import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SafeUrl } from '@angular/platform-browser';
import { Cobertura } from 'src/app/modelos/cotizacion.model';

@Component({
  selector: 'app-pago-en-linea-umitec',
  templateUrl: './pago-en-linea-umitec.component.html',
  styleUrls: ['./pago-en-linea-umitec.component.css']
})
export class PagoEnLineaUmitecComponent implements OnInit {

  public urlPayment: SafeUrl = "";
  public iframeHeigth = window.innerHeight > 800 ? 800 : window.innerHeight - 60;
  
  constructor(public dialog: MatDialogRef<PagoEnLineaUmitecComponent>) { }

  ngOnInit(): void {
  }

  onCloseModal() {
    this.dialog.close();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.iframeHeigth = window.innerHeight > 800 ? 800 : window.innerHeight - 60;
  }

}
